import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { AlertOctagon, ArrowLeft } from 'lucide-react'
import { usePermissions } from '../../auth/hooks/usePermissions'
import { PageCard, SectionLabel, TOKENS } from '../../../components/design-system'

// System ID surfaced in the 404 footer. Helps support correlate the
// user's complaint with a specific build / deploy. Falls back to
// 'dev' when the env isn't set (local development).
const SYSTEM_ID = process.env.REACT_APP_VERSION
  || process.env.REACT_APP_BUILD_ID
  || 'dev'

const Error404: FC = () => {
  const navigate = useNavigate()
  const perms = usePermissions()

  // Send the operator back to whatever makes sense for their role.
  // Pure fabricante users → "/manufacturer/stock"; everyone else →
  // "/dashboard". Same precedence as DefaultLanding.
  const homeTarget = (perms.is_manufacturer && !perms.is_admin_anywhere)
    ? '/manufacturer/stock'
    : '/dashboard'

  return (
    <div style={{
      minHeight: '70vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: TOKENS.spacing.lg,
    }}>
      <PageCard style={{ maxWidth: 520, width: '100%', textAlign: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: TOKENS.spacing.md }}>
          <div style={{
            width: 72, height: 72, borderRadius: '50%',
            background: TOKENS.color.severity.medium.bg,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <AlertOctagon size={36} color={TOKENS.color.severity.medium.text} />
          </div>
        </div>

        <SectionLabel>404 · Página não encontrada</SectionLabel>
        <h1 style={{
          fontSize: 28, fontWeight: 700, color: TOKENS.color.text,
          margin: `${TOKENS.spacing.xs}px 0 ${TOKENS.spacing.sm}px`,
        }}>
          Ops, esse endereço não existe
        </h1>
        <p style={{
          fontSize: 14, lineHeight: 1.6,
          color: TOKENS.color.muted,
          margin: 0,
          marginBottom: TOKENS.spacing.lg,
        }}>
          A página que você tentou abrir foi removida, mudou de URL, ou
          o link veio quebrado. Se chegou aqui através do menu ou de um
          botão do sistema, comunique o suporte com o ID do sistema
          abaixo pra investigarmos.
        </p>

        <button
          type='button'
          onClick={() => navigate(homeTarget)}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            background: TOKENS.color.action, color: '#fff', border: 'none',
            padding: '10px 18px', fontSize: 13, fontWeight: 700,
            borderRadius: TOKENS.radius.chip, cursor: 'pointer',
          }}
        >
          <ArrowLeft size={14} /> Voltar pra home
        </button>

        <div style={{
          marginTop: TOKENS.spacing.lg,
          paddingTop: TOKENS.spacing.md,
          borderTop: `1px solid ${TOKENS.color.border}`,
          fontSize: 10, fontWeight: 700, letterSpacing: 0.6,
          textTransform: 'uppercase',
          color: TOKENS.color.muted,
        }}>
          ID do sistema · CMB-WEB-{SYSTEM_ID}
        </div>
      </PageCard>
    </div>
  )
}

export { Error404 }
